/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type ContractFragmentFragment = { id: string, reference_id: string, minimum_order_value: number | null, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, is_trusted_supplier: boolean, order_count: number | null, supplyingCompanyId: string, buyingCompanyId: string, last_order_date: string | null, status: Types.Contract_Status_Enum, discount: number, channel_url: string | null, custom_price_list_id: string | null, sub_catalog_id: string | null, custom_price_list: { name: string, custom_price_list_packagings: Array<{ packaging_sku: number, company_id: string, discount: number }> } | null, sub_catalog: { name: string, sub_catalog_packagings: Array<{ packaging_sku: number, supplier_company_id: string }> } | null };

export const ContractFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment contractFragment on contract {
  id
  reference_id
  minimum_order_value
  minimum_order_value_type
  is_trusted_supplier
  order_count
  supplyingCompanyId
  buyingCompanyId
  last_order_date
  status
  discount
  channel_url
  custom_price_list_id
  custom_price_list {
    name
    custom_price_list_packagings {
      packaging_sku
      company_id
      discount
    }
  }
  sub_catalog_id
  sub_catalog {
    name
    sub_catalog_packagings {
      packaging_sku
      supplier_company_id
    }
  }
}
    `;